export default "/etc.clientlibs/des/cart-checkout/clientlibs/des-cart-checkout/resources/6dd9c20de52ba65d0cde8a5175773404.png";